import { gql } from '@apollo/client';

export const subsidyFields = `
  id
  amountElected
  amountEligible
  applicationId
  productId
  type
`;

export const applicantFields = `
  id
  applicationId
  productId
  personId
  externalId
  type
  isFiler
`;

export const productFields = `
  id
  applicationId
  planId
  fullPremium
  subsidizedPremium
  effectiveDate
  planVariant
  planVersion
`;

const SUBSIDY_QUERY = `
  subsidies {
    ${subsidyFields}
  }
`;

const APPLICANTS_QUERY = `
  applicants {
    ${applicantFields}
  }
`;

const PRODUCT_QUERY = `
  products {
    ${productFields}
  }
`;

const STATUS_QUERY = `
  statuses {
    id
    applicationId
    status
    createdAt
    updatedAt
    deletedAt
  }
`;

const ENROLLMENT_GROUP_QUERY = `
  enrollmentGroups {
    product {
      id
      planId
      planExternalId
      fullPremium
      region
      planVersion
      subsidizedPremium
      effectiveDate
      planVariant
    }
    applicants {
      id
      externalId
      personId
      isFiler
    }
    subsidy {
      id
      amountElected
      amountEligible
      productId
    }
  }
`;

const CURRENT_ENROLLMENT = `
  currentEnrollment {
    snapshot
  }
`;

export const consentFields = `
  id
  applicationId
  applicantId
  consentDate
  consentStatement
  consentStatementVersion
  consentMetadata {
    exchange
    consentUrl
    consentLocal
    firstName
    lastName
    agencyName
    ipAddress
    browserDetails
    state
  }
`;

const CONSENTS_QUERY = `
  consents {
    ${consentFields}
  }
`;

export const productAppQuery = `
  id
  type
  subType
  exchange
  ${ENROLLMENT_GROUP_QUERY}
  ${APPLICANTS_QUERY}
  ${PRODUCT_QUERY}
  ${SUBSIDY_QUERY}
  ${STATUS_QUERY}
  ${CURRENT_ENROLLMENT}
  ${CONSENTS_QUERY}
`;

export const getProductAppQuery = `
  getProductApp(
    applicationId: $applicationId,
  ) {
    ${productAppQuery}
  }
`;

const GET_PRODUCT_APP = gql`
  query GetProductApp($applicationId: ID!) {
    ${getProductAppQuery}
  }
`;

export default GET_PRODUCT_APP;
